import { IResponse, Model, ObjectsFactory } from '@/data'
import { SETTINGS_ENDPOINT } from '@/data/endpoint'

export type TTradeSetting = {
  minSize: number
  softCap: number
  hardCap: number
  fixedRateMinSize: number
  fixedRateMaxSize: number
}

export class TradeSetting extends Model {
  static config = { endpoint: SETTINGS_ENDPOINT.BASE }

  static objects = ObjectsFactory.factory<TTradeSetting>(TradeSetting.config)

  static async getTradeSetting() {
    return await this.service.get<IResponse<TTradeSetting>>({
      url: `${SETTINGS_ENDPOINT.TRADE}`,
    })
  }
}

TradeSetting.init(TradeSetting.config)
